import React, {useEffect} from "react";
import helpersFunction from '../_helpers/helpersFunction';


export default function LanderAutologinSoloRedirect(props) {

    
    useEffect(() => {
               
     
        if(!props.reload){
            
                var token = localStorage.getItem('token')
                helpersFunction.eventPost(props.clickid,null,"clickOnMail")
                //helpersFunction.logToBackend("Pixel Login by Mail",{pixel:true,clickid:props.clickid,et:"loginByMail",txid:props.contenutoMail+"_"+Date.now()})
                //helpersFunction.logToBackend("Pixel Click On Mail",{pixel:true,clickid:props.clickid,et:"clickOnMail"})
                try{
                    fetch(process.env.REACT_APP_APIADDRESS+"/users/"+props.clickid, {
                        method: 'get',
                        headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer '+ token,
                        'RemarketingClickid': props.remarketingClickid,
                        'tipoautologin':'telegram',
                        'eventoautologin':props.contenutoMail ? props.contenutoMail : 'non_definito',
                        }
                    })
                    .then(response => response.json())
                    .then(res => {
                        window.location.replace(props.red)
                    })
                    .catch((err)=>{
                        console.log("Errore chiamata landing autologin",err)
                        window.location.replace(props.red)
                    })
                }catch(err){
                    helpersFunction.logToBackend("Errore su recupero utente lander autologin",{err:err})
                }
       
            
           
        } 

        
    },[]); 

    return (
        <div>
            Redirecting...          
        </div>
        
 )

}